export default __webpack_public_path__ + "static/media/directory.247cd565.svg";